var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'rol-menu': true, 'ml-3': !_vm.mobile,  'custom-btn': _vm.mobile}},[(!_vm.mobile)?_c('span',{staticClass:"text-state text-state-md rol-menu mr-0",on:{"click":_vm.changeBots}},[_c('i',{staticClass:"fas fa-eye"}),_vm._v(_vm._s(_vm.changeView)+" ")]):_c('span',{staticClass:"i-btn i-eye",on:{"click":_vm.changeBots}})])
}
var staticRenderFns = []

export { render, staticRenderFns }